export class Switcher3D2DControl {
  constructor({ bearing = -20, pitch = 70 }) {
    this._bearing = bearing;
    this._pitch = pitch;
  }

  onAdd(map) {
    this._map = map;
    const _this = this;

    this._btn = document.createElement('button');
    this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-3d';
    this._btn.type = 'button';
    this._btn['aria-label'] = 'Toggle Pitch';
    this._btn.onclick = () => {
      if (map.getPitch() === 0) {
        const options = { pitch: _this._pitch, bearing: _this._bearing };
        map.easeTo(options);
        _this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-2d';
      } else {
        map.easeTo({ pitch: 0, bearing: 0 });
        _this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-pitchtoggle-3d';
      }
    };

    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-ctrl-group mapboxgl-ctrl';
    this._container.appendChild(this._btn);

    return this._container;
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._map = undefined;
  }
}
